import { getTaskFoldersService } from 'owa-todo-service';
import { processLoadedFolders } from '../actions/todoFolderStoreActions';
import { setLoadState } from '../mutators/todoFolderStoreMutators';
import type { TodoFolder } from 'owa-todo-types';
import getTodoFoldersLoadState from '../selectors/getTodoFoldersLoadState';
import { getFolders } from '../selectors/getFolders';

let currentRequest: Promise<TodoFolder[]> | null = null;

export async function loadFolders(): Promise<TodoFolder[]> {
    // TODO VSO 77990: Support task folder notifications
    const loadState = getTodoFoldersLoadState();
    if (loadState === 'Loaded') {
        return getFolders();
    }
    if (currentRequest) {
        return currentRequest;
    }
    currentRequest = loadFoldersInternal();
    const folders = await currentRequest;
    currentRequest = null;
    return folders;
}

async function loadFoldersInternal(): Promise<TodoFolder[]> {
    setLoadState('Fetching');
    const folders = await getTaskFoldersService();
    if (!folders) {
        setLoadState('Error');
        return [];
    }
    processLoadedFolders(folders);
    setLoadState('Loaded');
    return folders;
}
